// @internal
import React, { useContext } from 'react';
import Box from '../../../Box/Box';
import { SideNavContext } from '../../SideNavContext';
import SideNavIcon from '../SideNavIcon/SideNavIcon';
import SideNavTwiddle from '../SideNavTwiddle/SideNavTwiddle';
import { StyledSideNavGroupToggle, StyledSideNavGroupToggleLabel } from './styles';
import { SideNavGroupToggleProps } from './SideNavGroupToggle';

export const SideNavGroupToggleContent = ({
  onClick,
  alwaysShowMenuItems = false,
  icon = 'box',
  showMenuItems = false,
  title,
  isBadged = false,
  isActive = false,
  'data-testid': dataTestId,
}: SideNavGroupToggleProps) => {
  const { isClosed } = useContext(SideNavContext);

  return (
    <Box display="flex">
      <StyledSideNavGroupToggle
        data-testid={dataTestId ? `${dataTestId}-trigger` : ''}
        isClosed={isClosed}
        onClick={onClick}
        alwaysShowMenuItems={alwaysShowMenuItems}
      >
        <Box as="span" display="flex" alignItems="center">
          <SideNavIcon icon={icon} isBadged={isBadged} isActive={isActive} meaning={title} />
          <StyledSideNavGroupToggleLabel isClosed={isClosed} key="title">
            {title}
          </StyledSideNavGroupToggleLabel>
        </Box>
        {!alwaysShowMenuItems && <SideNavTwiddle open={showMenuItems} />}
      </StyledSideNavGroupToggle>
    </Box>
  );
};
